import { CSSObject } from '@chakra-ui/react';

export const WrapperContent: CSSObject = {
  display: 'flex',
  flexDir: 'column',
  py: ['4', null, '10'],
  px: ['2', null, '10'],
  flex: [null, null, 1],
  justifyContent: [null, null, 'center'],
  fontFamily: 'body',
  maxW: ['100vw', null, '500px'],
  bgGradient: 'linear(to-b, alpha.300, alpha.500)',
  borderTop: ['2px', '2px', '0px'],
  borderColor: 'beta.300',
  borderRightRadius: ['unset', null, 'lg'],
  'input:-webkit-autofill, input:-webkit-autofill:focus': {
    transition: 'background-color 0s 600000s, color 0s 600000s',
  },
  '.chakra-input__right-element': {
    color: 'white',
    '.chakra-button': {
      color: 'beta.300',
    },
  },
  '.chakra-form__error-message': {
    bg: 'red.600',
    color: 'white',
    boxShadow:
      '0px 2px 4px 0px rgba(0, 0, 0, 0.20), 0px 1px 0px 0px rgba(255, 255, 255, 0.20) inset',
    borderRadius: 'base',
    p: '1',
    fontWeight: 'medium',
    fontSize: 'xs',
  },
  '#title-dropdown-select, #state-select, #suburb-input, #postcode-input, #residential-input, #streetName-input, #streetNumber-input':
    {
      bg: 'alpha.700',
      color: '#fff',
      border: 'none',
      option: {
        color: 'black',
      },
      fontSize: 'xs',
      fontWeight: 'normal',
      _placeholder: {
        color: 'white',
      },
    },
  '.chakra-select__icon-wrapper': {
    color: 'white',
  },
  'ul[class*="AutoCompleteResultContainer"]': {
    zIndex: 1501,
  },
};

export const Title: CSSObject = {
  fontSize: 'normal',
  fontStyle: 'normal',
  fontWeight: '600',
  mb: '4',
  mt: [null, null, '9'],
};
